var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", layout: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs6: "",
                            sm6: "",
                            layout: "",
                            "align-center": "",
                            "justify-start": ""
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: { click: _vm.handleClose }
                            },
                            [
                              _c("v-icon", { attrs: { color: "#ffff" } }, [
                                _vm._v("close")
                              ])
                            ],
                            1
                          ),
                          _c("v-toolbar-title", [
                            _vm._v(" " + _vm._s(_vm.accion) + " Equipos ")
                          ])
                        ],
                        1
                      ),
                      !_vm.statusFinished
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs6: "",
                                sm6: "",
                                layout: "",
                                "align-center": "",
                                "justify-end": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pr-3",
                                  attrs: {
                                    color: "rgb(255 108 0)",
                                    disabled: _vm.btnDisabled
                                  },
                                  on: { click: _vm.handleEdit }
                                },
                                [
                                  _vm._v(
                                    "\n              Guardar Cambios\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "v-toolbar",
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { centered: "" },
                      model: {
                        value: _vm.tabs,
                        callback: function($$v) {
                          _vm.tabs = $$v
                        },
                        expression: "tabs"
                      }
                    },
                    [
                      _c("v-tabs-slider", { attrs: { color: "yellow" } }),
                      _c("v-tab", [_vm._v("Equipo")]),
                      _c("v-tab", [_vm._v("Activacion")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tabs,
                    callback: function($$v) {
                      _vm.tabs = $$v
                    },
                    expression: "tabs"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    [
                      _c("v-card", { attrs: { flat: "" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "cardnew",
                            attrs: { align: "center" }
                          },
                          [
                            _c("br"),
                            _c(
                              "v-flex",
                              { attrs: { md10: "" } },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "rounded-card" },
                                  [
                                    _c(
                                      "v-container",
                                      { attrs: { "grid-list-md": "" } },
                                      [
                                        _c(
                                          "div",
                                          { attrs: { align: "left" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { sm12: "" } },
                                              [
                                                _c(
                                                  "v-tabs-items",
                                                  {
                                                    model: {
                                                      value: _vm.tabs,
                                                      callback: function($$v) {
                                                        _vm.tabs = $$v
                                                      },
                                                      expression: "tabs"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "h2",
                                                      {
                                                        staticClass: "h2_title"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(_vm.accion) +
                                                            " Equipo " +
                                                            _vm._s(
                                                              _vm.data
                                                                .tipoeqname
                                                            ) +
                                                            "\n                          "
                                                        )
                                                      ]
                                                    ),
                                                    _vm.data.serienumero
                                                      ? _c(
                                                          "h2",
                                                          {
                                                            staticClass:
                                                              "h2_title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Serie Nro " +
                                                                _vm._s(
                                                                  _vm.data
                                                                    .serienumero
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("v-divider"),
                                                    !_vm.loading
                                                      ? _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              s12: "",
                                                              sm12: "",
                                                              "my-4": "",
                                                              layout: "",
                                                              wrap: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Equipo (Obligatorio)",
                                                                      "prepend-icon":
                                                                        "explore",
                                                                      items:
                                                                        _vm
                                                                          .filterApi
                                                                          .EQUIPOS,
                                                                      "item-text":
                                                                        "tipoeqname",
                                                                      "item-value":
                                                                        "tipoeqid",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .equipo
                                                                      ],
                                                                      "return-object":
                                                                        "",
                                                                      required:
                                                                        "",
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handleChange
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .equipo,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "equipo",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.equipo"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Número Serie (Obligatorio)",
                                                                      "prepend-icon":
                                                                        "abc",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .serienumero
                                                                      ],
                                                                      required:
                                                                        "",
                                                                      counter: 50,
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      keypress:
                                                                        _vm.handleOnlyNumbersAndLetters,
                                                                      change:
                                                                        _vm.handleChange
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .serienumero,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "serienumero",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.serienumero"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Serie IMEI",
                                                                      "prepend-icon":
                                                                        "abc",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .serieimei
                                                                      ],
                                                                      counter: 50,
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      keypress:
                                                                        _vm.handleOnlyNumbersAndLetters
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .serieimei,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "serieimei",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.serieimei"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Serie Cantidad Activa",
                                                                      type:
                                                                        "number",
                                                                      min: "0",
                                                                      max:
                                                                        "999999",
                                                                      "prepend-icon":
                                                                        "123",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .seriecant_activa
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .seriecant_activa,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "seriecant_activa",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.seriecant_activa"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "DatePicker",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Fecha Recuperación Cliente",
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .seriebateria_fecha,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "seriebateria_fecha",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.seriebateria_fecha"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Tipo Ubicación (Obligatorio)",
                                                                      items:
                                                                        _vm
                                                                          .filterApi
                                                                          .UBICACIONES,
                                                                      "item-text":
                                                                        "tipoubicaname",
                                                                      "item-value":
                                                                        "tipoubicaid",
                                                                      "prepend-icon":
                                                                        "pin_drop",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .tipoubicaid
                                                                      ],
                                                                      required:
                                                                        "",
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .tipoubicaid,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "tipoubicaid",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.tipoubicaid"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Costo Unitario",
                                                                      required:
                                                                        "",
                                                                      "prepend-icon":
                                                                        "price_change",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .costounitario
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handleCost,
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .costounitario,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "costounitario",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.costounitario"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Costo Unitario CLP",
                                                                      "prepend-icon":
                                                                        "price_change",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .costounitario
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handleCost,
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .costounitario_clp,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "costounitario_clp",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.costounitario_clp"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Costo Flete OC",
                                                                      "prepend-icon":
                                                                        "price_change",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .costounitario
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handleCost,
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .costoflete_oc,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "costoflete_oc",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.costoflete_oc"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Nuevo Precio Unitario",
                                                                      "prepend-icon":
                                                                        "price_change",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .costounitario
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handleCost,
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .nuevoprecio_unitario,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "nuevoprecio_unitario",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.nuevoprecio_unitario"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Factor Importación",
                                                                      "prepend-icon":
                                                                        "percent",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .factorimportacion
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handlePercent,
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .factorimportacion,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "factorimportacion",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.factorimportacion"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Nuevo Precio Unitario USD",
                                                                      "prepend-icon":
                                                                        "price_change",
                                                                      required:
                                                                        "",
                                                                      rules: [
                                                                        _vm
                                                                          .rules
                                                                          .costounitario
                                                                      ],
                                                                      disabled:
                                                                        _vm.statusFinished
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.handleCost,
                                                                      keypress:
                                                                        _vm.handleOnlyNumbers
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .nuevoprecio_unitariousd,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "nuevoprecio_unitariousd",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.nuevoprecio_unitariousd"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  xs12: "",
                                                                  sm4: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-checkbox",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Desinstalado"
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .paramApi
                                                                          .desinstalado,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.paramApi,
                                                                          "desinstalado",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "paramApi.desinstalado"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("br")
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c("v-card", { attrs: { flat: "" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "cardnew",
                                attrs: { align: "center" }
                              },
                              [
                                _c("br"),
                                _c(
                                  "v-flex",
                                  { attrs: { md10: "" } },
                                  [
                                    _c(
                                      "v-card",
                                      { staticClass: "rounded-card" },
                                      [
                                        _c(
                                          "v-container",
                                          { attrs: { "grid-list-md": "" } },
                                          [
                                            _c(
                                              "div",
                                              { attrs: { align: "left" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { sm12: "" } },
                                                  [
                                                    _c(
                                                      "FormFieldsContainer",
                                                      {
                                                        attrs: {
                                                          titulo: "Equipo"
                                                        }
                                                      },
                                                      [
                                                        !_vm.loading
                                                          ? _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  s12: "",
                                                                  sm12: "",
                                                                  "my-4": "",
                                                                  layout: "",
                                                                  wrap: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: false,
                                                                        expression:
                                                                          "false"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Número de Serie",
                                                                          "prepend-icon":
                                                                            "abc",
                                                                          disabled: true
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Número de Serie"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Número de Serie",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Número de Serie']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: false,
                                                                        expression:
                                                                          "false"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Tipo de Equipo ID",
                                                                          "prepend-icon":
                                                                            "abc",
                                                                          disabled: true
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Tipo de Equipo ID"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Tipo de Equipo ID",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Tipo de Equipo ID']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Número de Activación",
                                                                          "prepend-icon":
                                                                            "abc"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Número de Activación"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Número de Activación",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Número de Activación'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "DatePicker",
                                                                      {
                                                                        attrs: {
                                                                          locale:
                                                                            "es-cl",
                                                                          label:
                                                                            "Fecha de Alta",
                                                                          "prepend-icon":
                                                                            "event"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Fecha de Alta"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Fecha de Alta",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Fecha de Alta']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Es Arriendo: "
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Es Arriendo"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Es Arriendo",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Es Arriendo']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "ID Dispositivo",
                                                                          "prepend-icon":
                                                                            "devices_other"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "ID Dispositivo"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "ID Dispositivo",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['ID Dispositivo']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "AVL",
                                                                          "prepend-icon":
                                                                            "gps_fixed"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "AVL"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "AVL",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['AVL']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Número de Serie SIM",
                                                                          "prepend-icon":
                                                                            "sim_card"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Número de Serie SIM"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Número de Serie SIM",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Número de Serie SIM'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "DatePicker",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Fecha de Instalación",
                                                                          "prepend-icon":
                                                                            "today",
                                                                          locale:
                                                                            "es-cl"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Fecha de Instalación"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Fecha de Instalación",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Fecha de Instalación'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Patente Vehículo",
                                                                          "prepend-icon":
                                                                            "directions_car"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Patente Vehículo"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Patente Vehículo",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Patente Vehículo']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "DatePicker",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Fecha de Baja",
                                                                          "prepend-icon":
                                                                            "event_busy",
                                                                          locale:
                                                                            "es-cl"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Fecha de Baja"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Fecha de Baja",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Fecha de Baja']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Observaciones",
                                                                          "prepend-icon":
                                                                            "notes"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Observaciones"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Observaciones",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Observaciones']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Número de Asignación",
                                                                          "prepend-icon":
                                                                            "assignment"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Número de Asignación"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Número de Asignación",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Número de Asignación'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Plataforma Ingresada",
                                                                          "prepend-icon":
                                                                            "cloud_queue"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Plataforma Ingresada"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Plataforma Ingresada",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Plataforma Ingresada'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "DatePicker",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Fecha Plataforma",
                                                                          "prepend-icon":
                                                                            "event_note",
                                                                          locale:
                                                                            "es-cl"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Fecha Plataforma"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Fecha Plataforma",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Fecha Plataforma']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Plataforma",
                                                                          items:
                                                                            _vm
                                                                              .DROPDOWNS_SERIEACTIVA
                                                                              .PLATAFORMAS
                                                                              .LISTA,
                                                                          "item-text":
                                                                            "configvalor",
                                                                          "item-value":
                                                                            "configid",
                                                                          "prepend-icon":
                                                                            "pin_drop",
                                                                          disabled:
                                                                            _vm.statusFinished
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Plataforma"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Plataforma",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['Plataforma']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "EPC",
                                                                          "prepend-icon":
                                                                            "memory"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "EPC"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "EPC",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['EPC']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Modalidad",
                                                                          "prepend-icon":
                                                                            "swap_calls"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Modalidad"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Modalidad",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['Modalidad']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: false,
                                                                        expression:
                                                                          "false"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "RUT Cliente",
                                                                          "prepend-icon":
                                                                            "account_box"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "RUT Cliente"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "RUT Cliente",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['RUT Cliente']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Cliente",
                                                                          items:
                                                                            _vm
                                                                              .DROPDOWNS_SERIEACTIVA
                                                                              .CLIENTES
                                                                              .LISTA,
                                                                          "item-text":
                                                                            "nombre",
                                                                          "item-value":
                                                                            "id",
                                                                          "prepend-icon":
                                                                            "perm_identity",
                                                                          disabled:
                                                                            _vm.statusFinished
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "ID Cliente"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "ID Cliente",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['ID Cliente']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Flotas",
                                                                          items:
                                                                            _vm
                                                                              .DROPDOWNS_SERIEACTIVA
                                                                              .FLOTAS
                                                                              .LISTA,
                                                                          "item-text":
                                                                            "nomflota",
                                                                          "item-value":
                                                                            "cod_flota",
                                                                          "prepend-icon":
                                                                            "local_shipping",
                                                                          disabled:
                                                                            _vm.statusFinished
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "ID Flota"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "ID Flota",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['ID Flota']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Nro. Movimiento INET",
                                                                          "prepend-icon":
                                                                            "swap_horiz"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Nro. Movimiento INET"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Nro. Movimiento INET",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Nro. Movimiento INET'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Flag INET OK"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Flag INET OK"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Flag INET OK",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Flag INET OK']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Activación Finalizada"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Activación Finalizada"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Activación Finalizada",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Activación Finalizada'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Flag CRM OK"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Flag CRM OK"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Flag CRM OK",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Flag CRM OK']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Origen Registro",
                                                                          "prepend-icon":
                                                                            "source"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Origen Registro"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Origen Registro",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Origen Registro']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Patente Antigua",
                                                                          "prepend-icon":
                                                                            "history"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Patente Antigua"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Patente Antigua",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Patente Antigua']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Desinstalado"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Desinstalado"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Desinstalado",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos['Desinstalado']\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "CRM Alta",
                                                                          "prepend-icon":
                                                                            "arrow_upward"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "CRM Alta"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "CRM Alta",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['CRM Alta']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Glosa CRM",
                                                                          "prepend-icon":
                                                                            "comment"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Glosa CRM"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Glosa CRM",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['Glosa CRM']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Glosa INET",
                                                                          "prepend-icon":
                                                                            "comment"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Glosa INET"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Glosa INET",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['Glosa INET']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Número Movimiento INET",
                                                                          "prepend-icon":
                                                                            "shuffle"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Número Movimiento INET"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Número Movimiento INET",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "\n                                    Activaciones_equipos[\n                                      'Número Movimiento INET'\n                                    ]\n                                  "
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs12: "",
                                                                      sm4: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Tramo Baja",
                                                                          "prepend-icon":
                                                                            "trending_down"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .Activaciones_equipos[
                                                                              "Tramo Baja"
                                                                            ],
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm.Activaciones_equipos,
                                                                              "Tramo Baja",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "Activaciones_equipos['Tramo Baja']"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div")
            ],
            1
          ),
          _c("Confirmation", {
            attrs: {
              show: _vm.dialogConfirmation,
              titulo: _vm.confrmationData.title,
              mensaje: _vm.confrmationData.msg,
              textoBtnSi: _vm.confrmationData.btnAceptar,
              textoBtnNo: _vm.confrmationData.btnCancelar
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.handleConfirmation($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }